import type { FunctionComponent } from 'react';

import { Button } from '@kanda-libs/ks-design-library';

import Profile from 'components/shared/Profile';

import TrainingStatusModal from './TrainingStatusModal';
import useOnboarding from './useOnboarding';

const Onboarding: FunctionComponent = function () {
  const { stage, link, trainingStatus, onClick } = useOnboarding();

  return (
    <Profile.Section title="Onboarding details">
      <div className="flex flex-row w-full gap-x-4">
        <div className="my-auto">
          <Profile.Property label="Onboarding stage" value={stage} />
        </div>
        {link && (
          <a href={link} className="ml-auto" target="_blank" rel="noreferrer">
            <Button.Text
              id="staff-go-to-onboarding"
              label="Go to onboarding"
              className="w-44"
              size={32}
            />
          </a>
        )}
      </div>
      <>
        {trainingStatus ? (
          <div className="flex flex-row w-full gap-x-4 mt-2">
            <div className="my-auto">
              <Profile.Property
                label="Training status"
                value={trainingStatus}
              />
            </div>
            <Button.Text
              id="staff-go-to-onboarding"
              label="Update Training Status"
              className="w-44 ml-auto"
              size={32}
              onClick={onClick}
            />
            <TrainingStatusModal />
          </div>
        ) : null}
      </>
    </Profile.Section>
  );
};

export default Onboarding;
